import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import dotenv from 'react-dotenv';
import { getIAAM } from '../../reducer/iaamSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { getDisease } from '../../reducer/diseaseSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';
import { setPatient, setPatientChecked } from '../../reducer/patientSlice';
import { getAmphurData, getAmphurDataMap, getProvinceData, getProvinceDataMap, getTambonData } from '../../reducer/areaDataSlice';
import { getDengueSetting, setDenguePatient } from '../../reducer/dengueSettingSlice';

function PatientSetting(props) {
    // const {config} = props;
    const dispatch = useDispatch();
    const { patient } = useSelector(getDengueSetting);
    const provinceData = useSelector(getProvinceData);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurData = useSelector(getAmphurData);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonData = useSelector(getTambonData);
    const iaam = useSelector(getIAAM);
    const area_level = useSelector(getAreaLevel);
    const disease_class = useSelector(getDisease);
    const woy = useSelector(getWeekOfYear);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const getPatientSize = (patient) => {
            let sizePoint = [3, 6, 9, 12, 15];
            let indexSize;
            let found = false;

            // console.log(dotenv);
            let conditions = dotenv[`PATIENT_${area_level.toUpperCase()}`].split(",");
            // var conditions = config[area_level].split(",");
            for (let index = conditions.length - 1; index >= 0 && !found; index--) {
                const element = conditions[index];
                var condition = parseInt(element);
                if (patient >= condition) {
                    indexSize = index;
                    found = true;
                }
            }
            return sizePoint[indexSize];
        }
        const getAPI = async () => {
            let access_token = await iaam.getAccessToken();
            // console.log(access_token);
            // console.log(access_token)
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json', 
                    'Authorization': `bearer ${access_token}`
                }
            }
            let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/total-patient?area_level=${area_level}&disease_class=${disease_class}&start_week=${woy.start.week}&start_year=${woy.start.year}&end_week=${woy.end.week}&end_year=${woy.end.year}`, options);
            const resData = await res.json();
            let tmpData = {};
            for (let index = 0; index < resData.length; index++) {
                const element = resData[index];
                tmpData[element.code] = element.total_patients;
            }

            let provAttrName = "prov_namt";
            let provAttrCode = "prov_code";
            let ampAttrName = "amp_namt";
            let ampAttrCode = "amp_code";
            let tambonAttrName = "tambon_namt";
            let tambonAttrCode = "tambon_code";
            let tmpPatientData = {};
            
            if (area_level === "province") {
                for (let index = 0; index < provinceData.length; index++) {
                    const element = provinceData[index];
                    const patient = tmpData[element[provAttrCode]] !== undefined ? tmpData[element[provAttrCode]] : 0;
                    const size = getPatientSize(patient);
                    tmpPatientData[element[provAttrCode]] = {
                        code: element[provAttrCode],
                        name: element[provAttrName],
                        province_code: element[provAttrCode],
                        province_name: element[provAttrName],
                        patient: patient,
                        location: element.center_geojson_4326,
                        size: size
                    }
                }
            } else if (area_level === "amphur") {
                for (let index = 0; index < amphurData.length; index++) {
                    const element = amphurData[index];
                    const prov_code = element[ampAttrCode].substr(0, 2);
                    let provData = provinceMap[prov_code];
                    const patient = tmpData[element[ampAttrCode]] !== undefined ? tmpData[element[ampAttrCode]] : 0;
                    const size = getPatientSize(patient);
                    tmpPatientData[element[ampAttrCode]] = {
                        code: element[ampAttrCode],
                        name: element[ampAttrName],
                        amphur_code: element[ampAttrCode],
                        amphur_name: element[ampAttrName],
                        province_code: provData[provAttrCode],
                        province_name: provData[provAttrName],
                        patient: patient,
                        location: element.center_geojson_4326,
                        size: size
                    }
                }
            } else if (area_level === "tambon") {
                for (let index = 0; index < tambonData.length; index++) {
                    const element = tambonData[index];
                    const prov_code = element[tambonAttrCode].substr(0, 2);
                    const amp_code = element[tambonAttrCode].substr(0, 4);
                    let provData = provinceMap[prov_code];
                    let ampData = amphurMap[amp_code];
                    const patient = tmpData[element[tambonAttrCode]] !== undefined ? tmpData[element[tambonAttrCode]] : 0;
                    const size = getPatientSize(patient);
                    tmpPatientData[element[tambonAttrCode]] = {
                        code: element[tambonAttrCode],
                        name: element[tambonAttrName],
                        tambon_code: element[tambonAttrCode],
                        tambon_name: element[tambonAttrName],
                        amphur_code: ampData[ampAttrCode],
                        amphur_name: ampData[ampAttrName],
                        province_code: provData[provAttrCode],
                        province_name: provData[provAttrName],
                        patient: patient,
                        location: element.center_geojson_4326,
                        size: size
                    }
                }
            }
            dispatch(setPatient(tmpPatientData));
            // console.log(res.status);
        }
        if (iaam) {
            dispatch(setPatient({}));
            dispatch(setPatientChecked(checked));
            if (checked) {
                getAPI();   
            }
        }
    }, [checked, iaam, area_level, disease_class, woy, dispatch])

    useEffect(() => {
        setChecked(patient);
    }, [patient])
    
    return (
        <>
            <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
                if (disease_class === "1") {
                    dispatch(setDenguePatient(event.target.checked));
                } else {
                    setChecked(event.target.checked);
                }
            }}/>} label="จำนวนผู้ป่วย" />
        </>
    )
}

export default PatientSetting;